import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { createI18nProvider } from "i18n/createI18nProvider";
import { onIdle } from "utils/on-idle";

async function main() {
  const I18nProvider = createI18nProvider({
    path: "locales",
    namespace: ["translation"],
    supportedLocales: ["en-US", "fr-CA"],
    fallbackLocale: "en-US",
  });
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <I18nProvider>
          <HydratedRouter />
        </I18nProvider>
      </StrictMode>,
    );
  });
}

onIdle(() => void main());
